export const promedios = () => {

    function validarNumero(num) {
        let numm = num.toString().replace(",", ".")
        if (numm >= 0 && numm <= 10) {
            return true;
        } else {
            return false;
        }
    }
    const ifDecimal3 = (num) => {
        try {
            if (num != '') {
                var partes = num.toString().split('.');
                var re = /^-?[0-9]+$/;
                if (re.test(num)) {
                    return num + ".00";
                } else if (partes[1]?.length == 1) {
                    return num + "0";
                } else {
                    if(num==0) return '0.00'
                    if(num=='0.00') return '0.00'
                    return ifDecimal(trunc(num, 2))
                }
            } else {
                return '';
            }
        } catch (error) {
            return num
        }
    };
    const validarFormato = (params) => {
        if (params.value) {
            let formatted = params.value.toString().replace(',', '.');
            let result = formatted
            if (result >= 0 && result <= 10) {
                const salida = ifDecimal3(result)
                return salida;
            } else {
                return '⚠️';
            }
        }
    };
    //==============================PRIMER TRIMESTRE ============================
    const actividadTrim1 = function (params) {
        //TODO ACTIVIDADES INDIVIDUALES
        const param = params.data
        const nota1 = param.notas.a1 ? param.notas.a1.toString().replace(",", ".") : ''
        const nota2 = param.notas.a2 ? param.notas.a2.toString().replace(",", ".") : ''
        const nota3 = param.notas.a3 ? param.notas.a3.toString().replace(",", ".") : ''
        const nota4 = param.notas.a4 ? param.notas.a4.toString().replace(",", ".") : ''
        //TODO ACTIVIDADES GRUPALES

        const nota5 = param.notas.b1 ? param.notas.b1.toString().replace(",", ".") : ''
        const nota6 = param.notas.b2 ? param.notas.b2.toString().replace(",", ".") : ''
        const nota7 = param.notas.b3 ? param.notas.b3.toString().replace(",", ".") : ''
        const nota8 = param.notas.b4 ? param.notas.b4.toString().replace(",", ".") : ''

        const result = calcularActividades(nota1, nota2, nota3, nota4, nota5, nota6, nota7, nota8)
        return result;
    };
//calcProyecOrEva
    const ponderado90 = function (params) {
        var rest = params.getValue('total');
        var test = rest.toString().replace(",", ".")
        let res = calcular_porcentaje_paciales(test)
        return res;
    };
    const calcProyect = function (params) {
        let rest = params.getValue('notas.pry1');
        let test = rest?.toString().replace(",", ".")
        let res = calcProyecOrEva(test)
        return res;
    };
    const calcEval = function (params) {
        let rest = params.getValue('notas.exa1');
        let test = rest?.toString().replace(",", ".")
        let res = calcProyecOrEva(test)
        return res;
    };
    const ponderado10 = function (params) {
        var rest = params.getValue('notas.exa1');
        var test = rest ? rest.toString().replace(",", ".") : ''
        var rest2 = params.getValue('notas.pry1');
        var test2 = rest2 ? rest2.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_examen(test, test2)
        return res;
    };
    // function calcularPromedio_quimestre(n1, n2) {
    //     let aux1 = parseFloat(n1)
    //     let aux2 = parseFloat(n2)
    //     let suma = (aux2 + aux1).toFixed(2);
    //     if (suma == 0) return '0.00'
    //     if (isNaN(suma) || suma == '') suma = ''
    //     return suma
    // }
    const calcTrimestreUno = function (params) {
        let set = params.getValue('total80');
        let insum = set ? set.toString().replace(",", ".") : ''

        let set1 = params.getValue('py5');
        let proyec = set1 ? set1.toString().replace(",", ".") : ''

        let set2 = params.getValue('eva5');
        let evalu = set2 ? set2.toString().replace(",", ".") : ''
        
        let aux1 = Number(insum)
        let aux2 = Number(proyec)
        let aux3 = Number(evalu)
        let suma = (aux2 + aux1+ aux3).toFixed(2)
        if (suma == 0) return '0.00'
        if (isNaN(suma) || suma == '') suma = ''
        return suma
    };

    //TODO: implement CALCULAMOS CUALITATICO A NUMEROS
    const calcTrimestreUnoCulitativo = function (params) {
        let pro1 = params.getValue('total');
        let test1 = pro1 ? pro1.toString().replace(",", ".") : ''
        let pro3 = params.getValue('notas.pry1');
        let test3 = pro3 ? pro3.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_paciales(test1)
        let res2 = calcUnoPonderado(test3)
        let sum = calcularPromedio_quimestre(res, res2)
       
        return sum
    };

    //TODO: implement CALCULAMOS CUALITATICO A NUMEROS
    const calcTrimestreDosCulitativo = function (params) {
        let pro1 = params.getValue('total2');
        let test1 = pro1 ? pro1.toString().replace(",", ".") : ''
        let pro3 = params.getValue('notas.pry2');
        let test3 = pro3 ? pro3.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_paciales(test1)
        let res2 = calcUnoPonderado(test3)
        let sum = calcularPromedio_quimestre(res, res2)
        return sum
    };
    const promFinalCuartoDos = function (params) {
        let pro1 = params.getValue('total3');
        let test1 = pro1 ? pro1.toString().replace(",", ".") : ''
        let pro3 = params.getValue('notas.pry2');
        let test3 = pro3 ? pro3.toString().replace(",", ".") : ''
        let pro4 = params.getValue('notas.exa2');
        let test4 = pro4 ? pro4.toString().replace(",", ".") : ''
        let prim = calacular_dos_parciales(test1, test1)
        let res = calcular_porcentaje_paciales(prim)
        let res2 = calcular_porcentaje_examen(test3, test4)
        let sum = calcularPromedio_quimestre(res, res2)
        return sum
    };
       //TODO: implement CALCULAMOS CUALITATICO A NUMEROS
       const calcTrimestreTresCulitativo = function (params) {
        let pro1 = params.getValue('total3');
        let test1 = pro1 ? pro1.toString().replace(",", ".") : ''
        let pro3 = params.getValue('notas.pry3');
        let test3 = pro3 ? pro3.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_paciales(test1)
        let res2 = calcUnoPonderado(test3)
        let sum = calcularPromedio_quimestre(res, res2)
        return sum
    };

    function calcularCulaitativo(num) {
        if (!num || num == '') return ''
        if (num >= 9 && num <= 10) return 'EX'
        else if (num >= 7 && num <= 8.99) return 'MB'
        else if (num >= 4.01 && num <= 9.99) return 'B'
        else if (num <= 4) return 'R'
        else return ''
    }
    function calcularCulaitativoLetras(num) {
        if (!num || num == '') return ''
        if (num >= 9 && num <= 10) return 'DA'
        else if (num >= 7 && num <= 8.99) return 'AA'
        else if (num >= 4.01 && num <= 9.99) return 'PA'
        else if (num <= 4) return 'NA'
        else return ''
    }

    //TODO: implement CALCULAMOS CULIATATIVO EX B MB R
    const calcTrimestreUnoCualitativo = function (params) {
        let pro1 = params.getValue('total');
        let res = calcularCulaitativo(pro1)
        return res
    };
    //TODO: implement CALCULAMOS CULIATATIVO EX B MB R
    const calcTrimestreUnoCualiLetras = function (params) {
        let pro1 = params.getValue('t1');
        let res = calcularCulaitativoLetras(pro1)
        return res
    };

    //==============================SEGUNDO TRIMESTRE ============================
    const actividadTrim2 = function (params) {
        const param = params.data
        const nota1 = param.notas.c1 ? param.notas.c1.toString().replace(",", ".") : ''
        const nota2 = param.notas.c2 ? param.notas.c2.toString().replace(",", ".") : ''
        const nota3 = param.notas.c3 ? param.notas.c3.toString().replace(",", ".") : ''
        const nota4 = param.notas.c4 ? param.notas.c4.toString().replace(",", ".") : ''

        const nota5 = param.notas.d1 ? param.notas.d1.toString().replace(",", ".") : ''
        const nota6 = param.notas.d2 ? param.notas.d2.toString().replace(",", ".") : ''
        const nota7 = param.notas.d3 ? param.notas.d3.toString().replace(",", ".") : ''
        const nota8 = param.notas.d4 ? param.notas.d4.toString().replace(",", ".") : ''

        const result = calcularActividades(nota1, nota2, nota3, nota4, nota5, nota6, nota7, nota8)
        return result;
    };

    const ponderado90Dos = function (params) {
        var rest = params.getValue('total2');
        var test = rest.toString().replace(",", ".")
        let res = calcular_porcentaje_paciales(test)
        return res;
    };
    const ponderado10dos = function (params) {
        var rest = params.getValue('notas.exa2');
        var test = rest ? rest.toString().replace(",", ".") : ''
        var rest2 = params.getValue('notas.pry2');
        var test2 = rest2 ? rest2.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_examen(test, test2)
        return res;
    };
    const calcTrimestreDos = function (params) {
        var pro1 = params.getValue('total802');
        var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
        var pro2 = params.getValue('total202');
        var test2 = pro2 ? pro2.toString().replace(",", ".") : ''
        let res = calcularPromedio_quimestre(test1, test2)
        return res
    };
    //TODO: implement CALCULAMOS CULIATATIVO EX B MB R
    const calcTrimestreDosCualitativo = function (params) {
        let pro1 = params.getValue('t2');
        let res = calcularCulaitativo(pro1)
        return res
    };
    //TODO: implement CALCULAMOS CULIATATIVO EX B MB R
    const calcTrimestreDosCualiLetras = function (params) {
        let pro1 = params.getValue('t2');
        let res = calcularCulaitativoLetras(pro1)
        return res
    };

    //==============================TERCER TRIMESTRE ============================

    const actividadTrim3 = function (params) {
        const param = params.data
        const nota1 = param.notas.e1 ? param.notas.e1.toString().replace(",", ".") : ''
        const nota2 = param.notas.e2 ? param.notas.e2.toString().replace(",", ".") : ''
        const nota3 = param.notas.e3 ? param.notas.e3.toString().replace(",", ".") : ''
        const nota4 = param.notas.e4 ? param.notas.e4.toString().replace(",", ".") : ''

        const nota5 = param.notas.f1 ? param.notas.f1.toString().replace(",", ".") : ''
        const nota6 = param.notas.f2 ? param.notas.f2.toString().replace(",", ".") : ''
        const nota7 = param.notas.f3 ? param.notas.f3.toString().replace(",", ".") : ''
        const nota8 = param.notas.f4 ? param.notas.f4.toString().replace(",", ".") : ''

        const result = calcularActividades(nota1, nota2, nota3, nota4, nota5, nota6, nota7, nota8)
        return result;
    };

    const ponderado90Tres = function (params) {
        var rest = params.getValue('total3');
        var test = rest.toString().replace(",", ".")
        let res = calcular_porcentaje_paciales(test)
        return res;
    };
    const ponderado10Tres = function (params) {
        var rest = params.getValue('notas.exa3');
        var test = rest ? rest.toString().replace(",", ".") : ''
        var rest2 = params.getValue('notas.pry3');
        var test2 = rest2 ? rest2.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_examen(test, test2)
        return res;
    };
    const calcTrimestreTres = function (params) {
        var pro1 = params.getValue('total803');
        var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
        var pro2 = params.getValue('total203');
        var test2 = pro2 ? pro2.toString().replace(",", ".") : ''
        let res = calcularPromedio_quimestre(test1, test2)
        return res
    };
    //TODO: implement CALCULAMOS CULIATATIVO EX B MB R
    const calcTrimestreTresCualitativo = function (params) {
        let pro1 = params.getValue('t3');
        let res = calcularCulaitativo(pro1)
        return res
    };
    //TODO: implement CALCULAMOS CULIATATIVO EX B MB R
    const calcTrimestreTresCualiLetras = function (params) {
        let pro1 = params.getValue('t3');
        let res = calcularCulaitativoLetras(pro1)
        return res
    };

    //==============================FINALE ============================
    const ponderadoPROY10 = function (params) {
        var rest = params.getValue('resultados.pytf');
        var test = rest ? rest.toString().replace(",", ".") : ''
        let res = calcUnoPonderado(test)
        return res;
    };
    const ponderadoPROYEXAM10 = function (params) {
        var rest = params.getValue('resultados.pytf');
        var test = rest ? rest.toString().replace(",", ".") : ''
        var rest2 = params.getValue('resultados.examf');
        var test2 = rest2 ? rest2.toString().replace(",", ".") : ''
        let res = calcular_porcentaje_examen(test, test2)
        return res;
    };
    const sumatoriaProm = function (params) {
        var rest = params.getValue('resultados.suma10');
        var test = rest ? rest.toString().replace(",", ".") : ''
        var rest2 = params.getValue('resultados.suma90');
        var test2 = rest2 ? rest2.toString().replace(",", ".") : ''
        let suma10 = parseFloat(test)
        let suma90 = parseFloat(test2)
        let res = (suma10 + suma90).toFixed(2)
        if (isNaN(res) || res == '') res = ''
        return res;
    };

    var postsSupletorios = function (params) {
        const supl = params.data.resultados.supletorio ? params.data.resultados.supletorio.toString().replace(",", ".") : ''
        const promfin = params.data.resultados.promGen ? params.data.resultados.promGen.toString().replace(",", ".") : ''
        if (supl == '') {
            return params.data.resultados.promGen
        } else {
            const suple = parseFloat(supl)
            const final = parseFloat(promfin)
            var result = 0
            if (suple > 0 && suple <= 10) {
                if (suple >= 9 && suple <= 10) result = '8.00'
                else if (suple >= 8.6 && suple <= 8.9) result = '7.75'
                else if (suple >= 8 && suple <= 8.5) result = '7.50'
                else if (suple >= 7.6 && suple <= 7.9) result = '7.25'
                else if (suple >= 7 && suple <= 7.5) result = '7.00'
                else result = final
            } else {
                result = 0
            }
            return `${result}`;
        }
    }
    const processDataFromClipboard = (params) => {
        const data = [...params.data];
        const emptyLastRow =
            data[data.length - 1][0] === '' && data[data.length - 1].length === 1;
        if (emptyLastRow) {
            data.splice(data.length - 1, 1);
        }
        const lastIndex = params.api.getModel().getRowCount() - 1;
        const focusedCell = params.api.getFocusedCell();
        const focusedIndex = focusedCell.rowIndex;
        if (focusedIndex + data.length - 1 > lastIndex) {
            const resultLastIndex = focusedIndex + (data.length - 1);
            const numRowsToAdd = resultLastIndex - lastIndex;
            const rowsToAdd = [];
            for (let i = 0; i < numRowsToAdd; i++) {
                const index = data.length - 1;
                const row = data.slice(index, index + 1)[0];
                const rowObject = {};
                let currentColumn = focusedCell.column;
                row.forEach((item) => {
                    if (!currentColumn) {
                        return;
                    }
                    rowObject[currentColumn.colDef.field] = item;
                    currentColumn = params.columnApi.getDisplayedColAfter(
                        currentColumn
                    );
                });
                rowsToAdd.push(rowObject);
            }
        }
        return data;
    }

    return {
        ifDecimal3, validarFormato, validarNumero,
        actividadTrim1, ponderado90, ponderado10, calcTrimestreUno,calcEval,
        actividadTrim2, ponderado90Dos, ponderado10dos, calcTrimestreDos,
        actividadTrim3, ponderado90Tres, ponderado10Tres, calcTrimestreTres,
        ponderadoPROY10, sumatoriaProm, postsSupletorios, ponderadoPROYEXAM10,
        processDataFromClipboard, calcTrimestreUnoCualitativo, calcTrimestreUnoCualiLetras,
        calcTrimestreDosCualitativo, calcTrimestreDosCualiLetras, calcTrimestreTresCualitativo, calcTrimestreTresCualiLetras,
        calcTrimestreUnoCulitativo, calcTrimestreDosCulitativo, calcTrimestreTresCulitativo,
        promFinalCuartoDos,calcProyect,
    }
}

function trunc(x, posiciones = 0) {
    var s = x.toString()
    var decimalLength = s.indexOf('.') + 1
    var numStr = s.substr(0, decimalLength + posiciones)
    return Number(numStr)
}
function validarNumber(num) {
    if (num >= 0 && num <= 10) {
        return true;
    } else {
        return false;
    }
}
function ifDecimal(num) {
    if (num != '') {
        var partes = num.toString().split('.');
        var re = /^-?[0-9]+$/;
        if (re.test(num)) {
            return num + ".00";
        } else if (partes[1]?.length == 1) {
            return num + "0";
        } else {
            return num
        }
    } else {
        return '';
    }
};

function calcularActividades(n1, n2, n3, n4, n5, n6, n7, n8) {
    const array = []
    let promedio = 0;
    if (n1 != '' && validarNumber(n1)) array.push(n1)
    if (n2 != '' && validarNumber(n2)) array.push(n2)
    if (n3 != '' && validarNumber(n3)) array.push(n3)
    if (n4 != '' && validarNumber(n4)) array.push(n4)
    if (n5 != '' && validarNumber(n5)) array.push(n5)
    if (n6 != '' && validarNumber(n6)) array.push(n6)
    if (n7 != '' && validarNumber(n7)) array.push(n7)
    if (n8 != '' && validarNumber(n8)) array.push(n8)
    var sumatoria = array.reduce(function (acumulador, siguienteValor) {
        return acumulador + parseFloat(siguienteValor);
    }, 0);
    promedio = (sumatoria / array.length);
    let result = trunc(promedio, 2)
    if (result == 0) return '0.00';
    if (isNaN(result) || result == '') result = ''
    let salida = ifDecimal(result)
    return salida;
}

function calacular_dos_parciales(pa1, pa2) {
    var suma = parseFloat(pa1) + parseFloat(pa2)
    let promedio = (suma / 2);
    let result = trunc(promedio, 2)
    if (result == 0) return '0.00'
    if (isNaN(result) || result == '') result = ''
    let salida = ifDecimal(result)
    return salida;
}
function calcular_porcentaje_paciales(prom) {
    let aux = parseFloat(prom)
    let promedio = ((aux * 9) / 10);
    let result = trunc(promedio, 2)
    if (result == 0) return '0.00'
    if (isNaN(result) || result == '') result = ''
    let salida = ifDecimal(result)
    return salida;
}
function calcProyecOrEva(prom) {
    let aux = parseFloat(prom)
    let porc = (aux * 0.05);
    let result = trunc(porc, 2)
    if (result == 0) return '0.00'
    if (isNaN(result) || result == '') result = ''
    //if (result == undefined) result = ''
    let salida = ifDecimal(result)
    return salida;
}
function calcular_porcentaje_examen(nota, nota2) {
    let aux = parseFloat(nota)
    let aux2 = parseFloat(nota2)
    let res = calacular_dos(aux, aux2)
    let promedio = ((res * 1) / 10);
    let result = trunc(promedio, 2)
    if (result == 0) return ''
    if (isNaN(result) || result == '') result = ''
    let salida = ifDecimal(result)
    return salida;
}
function calcUnoPonderado(nota) {
    let aux = parseFloat(nota)
    let promedio = ((aux * 1) / 10);
    let result = trunc(promedio, 2)
    if (result == 0) return '0.00'
    if (isNaN(result) || result == '') result = ''
    let salida = ifDecimal(result)
    return salida;
}
function calacular_dos(pa1, pa2) {
    var suma = parseFloat(pa1) + parseFloat(pa2)
    let promedio = (suma / 2);
    let result = trunc(promedio, 2)
    if (result == 0) return ''
    if (isNaN(result) || result == '') result = ''
    let salida = ifDecimal(result)
    return salida;
}
function calcularPromedio_quimestre(n1, n2) {
    let aux1 = parseFloat(n1)
    let aux2 = parseFloat(n2)
    let suma = (aux2 + aux1).toFixed(2);
    if (suma == 0) return '0.00'
    if (isNaN(suma) || suma == '') suma = ''
    return suma
}
